import { __ } from '@wordpress/i18n';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const propelInit = function() {
const FOCUSABLE_SELECTOR =
	'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

const TITLE_ID = 'people-card-lightbox-title';
const TRANSITION_DURATION = 400;
let lightbox;
let panel;
let panelBody;
let closeButton;
let activeTrigger;

const trapFocus = (e) => {
	const focusable = Array.from(
		panel.querySelectorAll(FOCUSABLE_SELECTOR)
	).filter((element) => null !== element.offsetParent);

	if (0 === focusable.length) {
		return;
	}

	const first = focusable[0];
	const last = focusable[focusable.length - 1];
	const active = panel.ownerDocument.activeElement;

	if (e.shiftKey && active === first) {
		e.preventDefault();
		last.focus();
	} else if (!e.shiftKey && active === last) {
		e.preventDefault();
		first.focus();
	}
};

const closeLightbox = () => {
	if (!lightbox?.classList.contains('active')) {
		return;
	}

	lightbox.classList.remove('visible');
	document.removeEventListener('keydown', keydown);
	clearAllBodyScrollLocks();

	if (activeTrigger) {
		activeTrigger.focus();
		activeTrigger = null;
	}

	setTimeout(function () {
		lightbox.classList.remove('active');
		panelBody.innerHTML = '';
	}, TRANSITION_DURATION);
};

const keydown = (e) => {
	if ('Escape' === e.key) {
		closeLightbox();
	} else if ('Tab' === e.key) {
		trapFocus(e);
	}
};

const createLightbox = () => {
	lightbox = document.createElement('div');
	lightbox.className = 'people-card-lightbox';
	lightbox.setAttribute('data-color-mode', '3');

	const overlay = document.createElement('button');
	overlay.className = 'people-card-lightbox__overlay';
	overlay.type = 'button';
	overlay.setAttribute('aria-label', __('Close', 'propel'));
	overlay.addEventListener('click', closeLightbox);
	panel = document.createElement('div');
	panel.className = 'people-card-lightbox__panel';
	panel.setAttribute('role', 'dialog');
	panel.setAttribute('aria-modal', 'true');

	const closeButtonLabel = document.createElement('span');
	closeButtonLabel.className = 'sr-only';
	closeButtonLabel.textContent = __('Close', 'propel');
	closeButton = document.createElement('button');
	closeButton.className = 'people-card-lightbox__close';
	closeButton.type = 'button';
	closeButton.appendChild(closeButtonLabel);
	closeButton.addEventListener('click', closeLightbox);
	panelBody = document.createElement('div');
	panelBody.className = 'people-card-lightbox__body';
	panel.appendChild(closeButton);
	panel.appendChild(panelBody);
	lightbox.appendChild(overlay);
	lightbox.appendChild(panel);
	document.body.appendChild(lightbox);
};

const openLightbox = (e) => {
	const trigger = e.target.closest('.people-card__button');

	if (!trigger) {
		return;
	}

	const card = trigger.closest('.people-card');
	const template = card?.querySelector('.people-card__lightbox-content');

	if (!template) {
		return;
	}

	e.preventDefault();

	if (!lightbox) {
		createLightbox();
	}

	activeTrigger = trigger;
	panelBody.innerHTML = '';

	// Reuse the card's own image markup so the already-downloaded source is shown.
	const figure = card.querySelector('.people-card__image-wrapper');

	if (figure) {
		const figureClone = figure.cloneNode(true);
		figureClone.classList.add('people-card-lightbox__image-wrapper');
		panelBody.appendChild(figureClone);
	}

	panelBody.appendChild(template.content.cloneNode(true));

	const title = panelBody.querySelector('.people-card-lightbox__title');

	if (title) {
		title.id = TITLE_ID;
		panel.setAttribute('aria-labelledby', TITLE_ID);
	} else {
		panel.removeAttribute('aria-labelledby');
	}

	lightbox.classList.add('active');
	disableBodyScroll(panel, { reserveScrollBarGap: true });
	document.addEventListener('keydown', keydown);

	// Let the off-canvas state paint before transitioning the panel in.
	setTimeout(function () {
		lightbox.classList.add('visible');
		closeButton.focus();
	}, 1);
};

document.addEventListener('click', openLightbox);

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['people-card'] = window.propel.blocks['people-card'] || {};
window.propel.blocks['people-card'].script = propelInit;
